import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex align-items-center" }
const _hoisted_2 = { class: "title white-space-nowrap" }
const _hoisted_3 = { class: "flex flex-wrap gutter-y-s3 flex-grow-1 xl:justify-content-center" }
const _hoisted_4 = { class: "w-12 sm:w-4 xl:col-offset-1" }
const _hoisted_5 = { class: "flex mr-s2 align-items-center" }
const _hoisted_6 = {
  key: 0,
  class: "text-sm text-primary mt-s1 text-bolder"
}
const _hoisted_7 = { class: "w-12 sm:w-4 lg:w-3" }
const _hoisted_8 = { class: "mr-s2 flex align-items-center" }
const _hoisted_9 = { class: "mr-s1" }
const _hoisted_10 = { class: "w-12 sm:w-4 lg:w-3" }
const _hoisted_11 = { class: "mr-s2 flex align-items-center" }
const _hoisted_12 = { class: "mr-s1" }
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = { class: "w-12" }

import BigNumber from 'bignumber.js';
import { computed, toRef } from 'vue';
import { MIN_HODLER_APR } from '@/store/modules/staking/constants/AUTO_STAKING';
import { ENABLE_FAKE_CARDANO_NETWORK } from '@/helpers/fakeCardanoNetwork';
import roundMixin from '@/mixins/round.mixin';
import { format } from '@/utils/format';
import { getScanLink } from '@/sdk/utils';
import Caption from '@/components/Caption.vue';
import AutoPoolStake from '@/views/pages/investment/staking/pool/autoPool/AutoPoolStake.vue';
import ControlPanelCollapse from '@/components/ControlPanelCollapse.vue';
import HodlBanner from '@/views/pages/investment/staking/pool/autoPool/hodlBanner/HodlBanner.vue';
import LearnMoreDialog from '@/components/highRatesLearnMore/LearnMoreDialog.vue';
import InfoMessage from '@/components/InfoMessage.vue';
import { AutoStaking } from '@/sdk/entities/autoStaking';
import { useMilkomedaWSCBalanceADAIntoCardanoValidator } from '@/composables/milkomeda-wrapped-smartcontract/useMilkomedaWSCBalanceADAIntoCardanoValidator';
import TooltipIcon from '@/components/tooltip/TooltipIcon.vue';
import { useI18n } from 'vue-i18n';
import BluesTokenIcon from '@/components/token/BluesTokenIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AutoPool',
  props: {
    pool: null,
    autoStaking: { type: Boolean }
  },
  emits: ["sendTransaction"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'sendTransaction'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  pool: AutoStaking;
  autoStaking: boolean;
}

const { mathMixRound } = roundMixin.methods;
const { t } = useI18n();





const balanceADAIntoCardanoValidator = useMilkomedaWSCBalanceADAIntoCardanoValidator();

const isValidCardanoBalanceRef = toRef(
  balanceADAIntoCardanoValidator.milkomedaWSCBalanceADAIntoCardanoValidatorState,
  'isValidCardanoBalance',
);
const minADABalanceRef = toRef(
  balanceADAIntoCardanoValidator.milkomedaWSCBalanceADAIntoCardanoValidatorState,
  'minADABalance',
);

const isShowNotEnoughCurrencyForFee = computed(
  () => ENABLE_FAKE_CARDANO_NETWORK && !isValidCardanoBalanceRef.value,
);
const aprL = computed(() => {
  const APRRounded = props.pool.printHodlerAPR.multipliedBy(100).toFixed(2, BigNumber.ROUND_DOWN);

  return format(APRRounded, 'unlimited');
});
const isAprLTooLow = computed(() => {
  return props.pool.printHodlerAPR.multipliedBy(100).lt(MIN_HODLER_APR);
});

function printPercent(val) {
  if (val.lt(1)) {
    return `< 1%`;
  }
  return val.gt(10000) ? `> 10000%` : `${mathMixRound(val, 2)}%`;
}
function getContractUrl() {
  return getScanLink(props.pool.farm, 'address');
}
function openExternalLink(url) {
  window.open(url, '_blank');
}
function openDocs() {
  openExternalLink(
    'https://blueshift-fi.gitbook.io/product-docs/product-concept/yield-pools/auto-hodl-blues-pool',
  );
}
function onSendTransaction() {
  emits('sendTransaction');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ControlPanelCollapse, {
    "contract-url": getContractUrl(),
    "toggle-inline": ""
  }, {
    "header-title": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)(`yieldPool.auto.poolTitle.caption`)), 1),
        _createVNode(TooltipIcon, {
          tooltip: _unref(t)(`yieldPool.auto.poolTitle.tooltip`)
        }, null, 8, ["tooltip"])
      ])
    ]),
    "header-data": _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(Caption, {
            caption: _unref(t)('yieldPool.auto.apy.caption'),
            tooltip: _unref(t)('yieldPool.auto.apy.tooltip'),
            class: "mb-s1"
          }, null, 8, ["caption", "tooltip"]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString(printPercent(__props.pool.printApy)), 1),
            _createVNode(LearnMoreDialog, {
              "data-source": "staking",
              type: "APY",
              "as-icon": ""
            })
          ]),
          (!_unref(isAprLTooLow))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(t)('yieldPool.auto.percentAsHodler', { percent: _unref(aprL) })), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(Caption, {
            caption: _unref(t)('yieldPool.auto.poolCompound.caption'),
            tooltip: _unref(t)('yieldPool.auto.poolCompound.tooltip'),
            class: "mb-s1 md:mb-s1"
          }, null, 8, ["caption", "tooltip"]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(format)(__props.pool.printTotalStake)), 1),
            _createVNode(BluesTokenIcon, { size: "12" })
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(Caption, {
            caption: _unref(t)('yieldPool.auto.newRewards.caption'),
            tooltip: _unref(t)('yieldPool.auto.newRewards.tooltip'),
            class: "mb-s1 md:mb-s1"
          }, null, 8, ["caption", "tooltip"]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(format)(__props.pool.printYouEarned)), 1),
            _createVNode(BluesTokenIcon, { size: "12" })
          ])
        ])
      ])
    ]),
    default: _withCtx(() => [
      (_unref(isShowNotEnoughCurrencyForFee))
        ? (_openBlock(), _createBlock(InfoMessage, {
            key: 0,
            type: "error",
            "as-panel": "",
            class: "mb-s3"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('wrappedContract.notEnoughCurrencyForFee', { amount: _unref(minADABalanceRef), symbol: 'ADA' })), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(HodlBanner, {
            class: "mb-s3",
            onOpenDocs: openDocs
          }),
          _createVNode(AutoPoolStake, {
            pool: __props.pool,
            "wsc-ada-validator": _unref(balanceADAIntoCardanoValidator),
            onSendTransaction: onSendTransaction
          }, null, 8, ["pool", "wsc-ada-validator"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["contract-url"]))
}
}

})